import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import { AudioCategorySelectorNew } from '../../components/menus/AudioCategorySelectorNew';
import { SoundItemRenderer } from '../../components/menus/SoundItemRenderer';
import { expandAudioList } from '../../actions/MenuActions';
import { setMediaFilesDataProvider } from '../../actions/AccordionActions';
import locales from '../../locales/LocalesManager';
import configuration from '../../constants/Configuration';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import { changeMainAudioCategoryIndex } from '../../actions/MusicActions';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import platformDetection from '../utils/PlatformDetection';
import hoverManager from '../utils/HoverManager';
import modeType from '../../constants/ModeConstants';

const AudioList = React.createClass({
    getInitialState() {
        return {
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.dataProvider != nextProps.dataProvider)
            this.recreateElements();
    },
    recreateElements() {
        setTimeout(this.refreshNewContent, 50);
    },
    refreshNewContent() {
        this.initElements();
    },
    initElements() {
        var elements = [];
        var i;
        var item;

        for (i=0; i<this.props.dataProvider.length; i++) {
            item = this.props.dataProvider[i];
            elements.push(<SoundItemRenderer accordionWidth={this.props.accordionWidth} categoryIndex={this.props.categoryIndex} index={i} key={'audioBrowser' + item.title + '_' + i} dispatch={this.props.dispatch} value={item}/>);
        }

        this.setState({
            elements
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.secondCategoryVisible != newProps.secondCategoryVisible || this.props.windowHeight != newProps.windowHeight || this.props.dataProvider != newProps.dataProvider)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        var categoryHeight = 0;
        var topPosition = this.props.buttonsHeight;
        const bottomPadding = 8;
        var topPadding = properties.CATEGORY_SELECTOR_GAP;
        var topButtonsPosition = properties.CLIPART_BUTTON_HEIGHT;

        if (this.props.categoryVisible == true) {
            categoryHeight = properties.CATEGORY_SELECTOR_HEIGHT;
            topPosition = topPosition + categoryHeight;
            topPadding = 0;
        }

        if (platformDetection.isIOS()) {
            topButtonsPosition = 3 * properties.CLIPART_BUTTON_HEIGHT;
        }

        topPosition = topPosition + topPadding;
        var uploadButtonHeight = 0;

        if (this.props.showUploadButton) {
            uploadButtonHeight = 50;
            topPosition = topPosition + uploadButtonHeight;
        }

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.height - categoryHeight - bottomPadding - topButtonsPosition - topPadding - uploadButtonHeight;
        componentProperties.top = topPosition;
        componentProperties.displayState = 'block';
        componentProperties.elements = this.state.elements;
        componentProperties.isAudioEditor = true;
        componentProperties.scrollHeight = (properties.SOUND_ITEM_HEIGHT + properties.SOUND_ITEMS_GAP) * this.state.elements.length;

        return (
            <ScrollableComponent componentProperties={componentProperties}/>
        );
    }
});

const TabElement = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;
        const state = storeManager.getState();
        const selectedIndex = state.music.mainAudioCategoryIndex;

        if (this.props.index == selectedIndex) {
            if (platformDetection.isIOS())
                dispatch(changeMainAudioCategoryIndex(-1));
        } else
            dispatch(changeMainAudioCategoryIndex(this.props.index));
    },
    render() {
        var isIos = platformDetection.isIOS();
        var buttonColor;
        var textColor;
        var icon;
        var iconColor;
        var topPosition = isIos ? this.props.topPosition : 0;
        var buttonWidth = isIos ? this.props.accordionWidth : (this.props.accordionWidth - 3) / 3;
        var leftPosition = isIos ? 0 : this.props.index * buttonWidth + this.props.index;
        var buttonHeight = properties.CLIPART_BUTTON_HEIGHT;
        var padding = isIos ? properties.BROWSER_LEFT_PADDING : 0;

        if (this.props.index == this.props.selectedIndex) {
            buttonColor = properties.BROWSER_SELECTED_COLOR;
            textColor = '#F7F7F7';
            icon = 'fa fa-angle-down';
            iconColor = 'white';
        }
        else {
            icon = 'fa fa-angle-right';
            iconColor = 'black';

            if (this.state.isOver == true) {
                buttonColor = properties.BROWSER_HOVER_COLOR;
                textColor = '#2299D6';
            } else {
                if (isIos)
                    buttonColor = properties.BROWSER_COLOR;
                else
                    buttonColor = properties.SOUND_EVEN_COLOR;

                textColor = '#000000';
            }
        }

        var tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: buttonWidth,
            height: buttonHeight,
            top: topPosition,
            left: leftPosition,
            color: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none'
        };

        var spanStyle = {
            position: 'absolute',
            top: 5,
            left: padding,
            color: textColor,
            fontSize: 15,
            width: buttonWidth - 4 * padding,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        var iconElement;

        if (isIos) {
            const iconStyle = {
                position: 'absolute',
                top: 11,
                right: properties.BROWSER_ICON_RIGHT_PADDING,
                color: iconColor
            };

            iconElement = <i style={iconStyle} className={icon}></i>;
        } else {
            spanStyle.textAlign = 'center';
        }

        if (isIos) {
            tabStyle.outlineColor = 'white';
            tabStyle.outlineWidth = 1;
            tabStyle.outlineStyle = 'solid';

            return (
                <div style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <span style={spanStyle}>{this.props.title}</span>
                    {iconElement}
                </div>
            );
        } else {
            tabStyle.margin = 0;
            tabStyle.padding = 0;
            tabStyle.boxSizing = 'initial';
            tabStyle.fontSize = 'initial';
            tabStyle.borderStyle = 'none';

            return (
                <button style={tabStyle} aria-label={this.props.title} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <span style={spanStyle}>{this.props.title}</span>
                    {iconElement}
                </button>
            );
        }
    }
});

export const AudioToolBrowserContent = React.createClass({
    getInitialState() {
        return {
            isMyMediaFilesCallDone: false,
        };
    },
    getClipartModel () {
        const clipartModel = storeManager.getState().music.soundClipartModel;
        return clipartModel;
    },
    getMySoundsCategories() {
        var dataProvider = [];

        dataProvider.push(locales.getCaption('UploadedSounds', 'music'));
        dataProvider.push(locales.getCaption('RecordedSounds', 'music'));

        return dataProvider;
    },
    getSelectorDataProvider (type) {
        const clipartModel = this.getClipartModel();

        if (!clipartModel)
            return [];

        const clipartModelItems = clipartModel.items;
        var dataProvider = [];
        var i;

        if (type == 'main') {
            dataProvider.push(clipartModelItems[0].title);
            dataProvider.push(clipartModelItems[1].title);
            dataProvider.push(locales.getCaption('MySoundsContent', 'music'));
        } else {
            var mainIndex = this.getSelectedIndex('main');

            if (mainIndex >= 0) {
            } else
                mainIndex = 0;

            const itemsObject = clipartModelItems[mainIndex];

            if (itemsObject === undefined)
                return dataProvider;

            const subcategoryItems = itemsObject.items;

            for (i = 0; i < subcategoryItems.length; i++) {
                dataProvider.push(subcategoryItems[i].title);
            }
        }

        return dataProvider;
    },
    getSelectedIndex (type) {
        var index;

        if (type == 'main') {
            index = this.props.mainAudioCategoryIndex;
        } else {
            index = this.props.secondAudioCategoryIndex;
        }

        if (index == undefined || isNaN(index))
            index = 0;

        return index;
    },
    getMusicDataProvider(mainIndex) {
        const clipartModel = this.getClipartModel();

        if (!clipartModel)
            return [];

        const clipartModelItems = clipartModel.items;

        if (clipartModelItems == undefined)
            return [];

        if (mainIndex == -1)
            return [];

        const secondIndex = this.getSelectedIndex('second');
        const subcategoryItems = clipartModelItems[mainIndex].items;

        if (subcategoryItems == undefined)
            return [];

        var dataProvider = [];
        const contentItems = subcategoryItems[secondIndex].items;
        var i;

        for (i = 0; i < contentItems.length; i++) {
            dataProvider.push(contentItems[i]);
        }

        return dataProvider;
    },
    filterMySounds(dataProvider) {
        var category = this.getSelectedIndex('second');
        var i;
        var array = [];

        for (i=0; i<dataProvider.length; i++) {
            if (category == 1) {// recorded sounds
                if (dataProvider[i] && dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            } else {
                if (dataProvider[i] && !dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            }
        }

        return array;
    },
    getMySoundsDataProvider () {
        const dataProvider = this.props.mediaFilesDataProvider;

        if (dataProvider && dataProvider.soundsDataProvider && dataProvider.soundsDataProvider.length > 0)
            return this.filterMySounds(dataProvider.soundsDataProvider);
        else {
            if (this.state.isMyMediaFilesCallDone == true)
                return [];

            setTimeout(this.loadData, 2);

            return [];
        }
    },
    loadData() {
        if (configuration.LOAD_LOCAL == true) {
            // FOR TEST
            this.props.dispatch(setMediaFilesDataProvider({imagesDataProvider: populateMediaFilesUtils.getImagesDataProviderForTest(), soundsDataProvider: populateMediaFilesUtils.getSoundsDataProviderForTest()}));
        } else {
            this.setState({isMyMediaFilesCallDone: true});
            apiServiceUtils.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
        }
    },
    loadMyMediaFiles() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems (items) {
        populateMediaFilesUtils.parseMediaItems(items, this.props.dispatch, true);
        this.setState({isMyMediaFilesCallDone: false});
    },
    category() {
        if (this.props.mainAudioCategoryIndex == undefined)
            return -1;
        else
            return this.props.mainAudioCategoryIndex;
    },
    getContentDataProvider () {
        var category = this.category();

        if (category == 0 || category == 1)
            return this.getMusicDataProvider(category);
        else
            return this.getMySoundsDataProvider();
    },
    isCategoryVisible() {
        var category = this.category();

        if (category == 0 || category == 1)
            return true;
        else
            return false;
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const target = e.target;
        if (this.hasParentWithId(target, 'categorySelector', 7) == false) {
            this.props.dispatch(expandAudioList(false, 'all'));
        }

        setTimeout(this.refreshView, 5);
    },
    hasParentWithId(target, parentId, level) {
        if (target.id == parentId)
            return true;

        var i;

        for (i=0; i<level; i++) {
            if (target.parentNode == undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id == parentId)
                    return true;
            }
        }

        return false;
    },
    getTabTopPosition(index, length, selectedIndex) {
        let topPosition = properties.CLIPART_BUTTON_HEIGHT * index;
        var clipartButtonHeight = properties.CLIPART_BUTTON_HEIGHT;

        if (audioToolUtils.isAudioTool())
            clipartButtonHeight = 0;

        if (selectedIndex != 0 && selectedIndex != 1 && selectedIndex != 2) {
            topPosition = index * properties.CLIPART_BUTTON_HEIGHT;
        } else {
            if (index <= selectedIndex)
                topPosition = index * properties.CLIPART_BUTTON_HEIGHT;
            else
                topPosition = this.props.windowHeight - clipartButtonHeight - properties.CLIPART_BUTTON_HEIGHT * (length - index);
        }

        return topPosition;
    },
    refreshView() {
        this.forceUpdate();
    },
    onUpload(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        window.parent.postMessage('openUploader', '*');
    },
    onMouseIn () {
        var button = document.getElementById('uploadButton');
        hoverManager.show(button, 'uploadButton');
    },
    onMouseOut () {
        hoverManager.hide();
    },
    shouldComponentUpdate(newProps) {
        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.musicContentIndex != newProps.musicContentIndex || this.props.secondAudioCategoryIndex != newProps.secondAudioCategoryIndex || this.props.mainAudioCategoryIndex != newProps.mainAudioCategoryIndex || this.props.secondAudioCategoryIsExpanded != newProps.secondAudioCategoryIsExpanded || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.mainAudioCategoryIsExpanded != newProps.mainAudioCategoryIsExpanded || this.props.contextMode != newProps.contextMode)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.contextMode == modeType.SEARCH_CONTEXT)
            return (<div/>);

        var menuStyle = {
            position: 'absolute',
            top: this.props.top,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            outlineColor: 'white',
            outlineWidth: 1,
            outlineStyle: 'solid'
        };

        if (audioToolUtils.isAudioTool())
            menuStyle.outlineWidth = 0;

        var leftPosition = 0;

        if (this.props.accordionWidth > properties.BROWSER_WIDTH)
            leftPosition = (this.props.accordionWidth - properties.BROWSER_WIDTH) / 2;

        const elementsHolder = {
            position: 'absolute',
            top: 0,
            left: leftPosition,
            width: this.props.accordionWidth,
            height: this.props.height,
            cursor: 'default',
            overflowX: 'auto',
            overflowY: 'hidden'
        };

        var mainDataProvider = this.getSelectorDataProvider('main');
        var i;
        var tabs = [];

        for (i=0; i<mainDataProvider.length; i++) {
            tabs.push(<TabElement key={'tabElement_' + i} accordionWidth={this.props.accordionWidth} topPosition={this.getTabTopPosition(i, mainDataProvider.length, this.props.mainAudioCategoryIndex)} title={mainDataProvider[i]} index={i} selectedIndex={this.props.mainAudioCategoryIndex} windowHeight={this.props.windowHeight}/>);
        }

        var list;
        var categorySelector;
        var uploadButton;

        if (this.props.mainAudioCategoryIndex == 0 || this.props.mainAudioCategoryIndex == 1 || this.props.mainAudioCategoryIndex == 2) {
            var buttonsHeight = platformDetection.isIOS() ? (this.props.mainAudioCategoryIndex + 1) * properties.CLIPART_BUTTON_HEIGHT : properties.CLIPART_BUTTON_HEIGHT;
            var dataProvider = this.props.mainAudioCategoryIndex == 2 ? this.getMySoundsCategories() : this.getSelectorDataProvider('second');
            var showUploadButton = !platformDetection.isIOSApp() && this.props.mainAudioCategoryIndex == 2 && (!this.props.secondAudioCategoryIndex || this.props.secondAudioCategoryIndex == 0);

            list = <AudioList accordionWidth={properties.BROWSER_WIDTH} buttonsHeight={buttonsHeight} showUploadButton={showUploadButton} categoryVisible={true} height={this.props.height} categoryIndex={this.props.mainAudioCategoryIndex} windowHeight={this.props.windowHeight} dispatch={this.props.dispatch} dataProvider={this.getContentDataProvider()}/>;
            categorySelector = <AudioCategorySelectorNew top={buttonsHeight} accordionWidth={properties.BROWSER_WIDTH} type={'second'} isAdvancedMenu={true} visible={true} isExpanded={this.props.secondAudioCategoryIsExpanded} selectedIndex={this.getSelectedIndex('second')} dataProvider={dataProvider} dispatch={this.props.dispatch}/>;

            if (showUploadButton) {
                if (platformDetection.isIOS()) {
                    var uploadIconStyle = {
                        position: 'absolute',
                        top: 85,
                        left: properties.BROWSER_WIDTH/2 - 42/2,
                        color: '#2DE102'
                    };

                    uploadIconStyle.top = uploadIconStyle.top + 2 * properties.CLIPART_BUTTON_HEIGHT;

                    uploadButton = <i id='uploadButton' style={uploadIconStyle} className="fa fa-plus-circle fa-3x" onMouseDown={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}/>;
                } else {
                    var uploadButtonStyle = {
                        position: 'absolute',
                        top: 85,
                        left: properties.BROWSER_WIDTH/2 - 42/2,
                        margin: 0,
                        padding: 0,
                        boxSizing: 'initial',
                        fontSize: 'initial',
                        borderStyle: 'none',
                        width: 41,
                        height: 48,
                        background: 'none'
                    };

                    var uploadIconPlusStyle = {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        color: '#2DE102'
                    };

                    uploadButton =
                        <button id='uploadButton' aria-label={locales.getCaption('UploadHover', 'myFiles')}
                                style={uploadButtonStyle} onClick={this.onUpload} onTouchStart={this.onUpload}
                                onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                            <i style={uploadIconPlusStyle} className="fa fa-plus-circle fa-3x"/>
                        </button>;
                }
            }
        }

        return (
            <div ref='audioBrowser' style={menuStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <div style={elementsHolder}>
                    {tabs}
                    {categorySelector}
                    {uploadButton}
                    {list}
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();

    var mainAudioCategoryIsExpanded = state.menu.mainAudioCategoryIsExpanded;
    const secondAudioCategoryIsExpanded = state.menu.secondAudioCategoryIsExpanded;
    const mainAudioCategoryIndex = state.music.mainAudioCategoryIndex;
    const secondAudioCategoryIndex = state.music.secondAudioCategoryIndex;
    const musicContentIndex = state.music.musicContentIndex;
    const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
    const contextMode = state.menu.contextMode;

    return {
        mainAudioCategoryIsExpanded,
        secondAudioCategoryIsExpanded,
        mainAudioCategoryIndex,
        secondAudioCategoryIndex,
        musicContentIndex,
        mediaFilesDataProvider,
        contextMode
    };
}

export const AudioToolBrowser = connect(mapStateToProps)(AudioToolBrowserContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/AudioToolBrowser.js
 **/